export const FETCH_PUSH_NOTIFICATIONS_SUCCESS = "FETCH_PUSH_NOTIFICATIONS_SUCCESS";
export const FETCH_PUSH_NOTIFICATIONS = "FETCH_PUSH_NOTIFICATIONS";
